const UARegEx = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
class Utils {
  /**
  * validate key nav_visiblity in APA
  * @param{string}  key APA
  * @returns Parse key or null
  **/

  static nav_visibilityExists(key) {
    if (key) return JSON.parse(key);
    return null;
  }

  /*
  * Add properties in Object from key APA nav_visibility
  * @param{object} source
  * @param{object} visibility
  * @return{object} or {null}
  */

  static addProperties(source, visibility) {
    let properties;
    let notVisible = false;
    let obj;

    if (visibility.length > 0) {
      properties = visibility[0];
    }

    /* Validate if source is not visible  */

    visibility.map((it) => {
      if (source.code == it.code) {
        notVisible = true;
        return;
      }
    });

    if (!notVisible) {
      Object.keys(properties).forEach((key) => {
        if (key != 'code') source[key] = 1;
      });

      return source;
    }
    visibility.map((it) => {
      if (source.code == it.code) {
        obj = it;
      }
    });

    Object.keys(obj).forEach((key) => {
      if (key != 'code') source[key] = obj[key];
    });

    return source;
  }

  /*
  * Add properties in the childs of a Object from key APA nav_visibility
  * @param{object}
  * @param{object}
  * @return{Array} news n childs of a object
  */

  static nChilds(source, visibility) {
    const childs = (s) => {
      s.map((it) => {
        this.addProperties(it, visibility);

        if (it.childs) {
          childs(it.childs);
        }
      });

      return s;
    };

    if (Array.isArray(source)) {
      return childs(source);
    }
  }

  /**
   * Returns the value of query string parameter by name, if not present returns false
   * @param {string} name
   * @return{string} query param value or null if not present
  */
  static getQueryParameter(name) {
    const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  static parseUrl(url) {
    const parser = document.createElement('a');
    parser.href = url;
    return {
      protocol: parser.protocol,
      hostname: parser.hostname,
      port: parser.port,
      pathname: parser.pathname,
      search: parser.search,
      hash: parser.hash,
      host: parser.host,
    };
  }
  
  static MobileCheck() {
    return UARegEx.test(navigator.userAgent);
  }
}

export default Utils;
